import { render, staticRenderFns } from "./withdraw-record.vue?vue&type=template&id=ee38787c&scoped=true"
import script from "./withdraw-record.vue?vue&type=script&lang=js"
export * from "./withdraw-record.vue?vue&type=script&lang=js"
import style0 from "./withdraw-record.vue?vue&type=style&index=0&id=ee38787c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee38787c",
  null
  
)

export default component.exports